import { IUnitedSubSections } from 'constants/businessToolSections';
import { FOR_BANK_SECTIONS, IForBankSections } from 'constants/businessToolSections/forBank';

import { AboutCompany } from 'components/BusinessToolForm/Sections/AboutCompany';
import { BusinessOperations } from 'components/BusinessToolForm/Sections/BusinessOperations';
import { ExecutiveSummary } from 'components/BusinessToolForm/Sections/ExecutiveSummary';
import { FinancialPlan } from 'components/BusinessToolForm/Sections/FinancialPlan';
import { ImplementationPlan } from 'components/BusinessToolForm/Sections/ImplementationPlan';
import { LegalFrameworkAndRisks } from 'components/BusinessToolForm/Sections/LegalFrameworkAndRisks';
import { ManagementAndOrganization } from 'components/BusinessToolForm/Sections/ManagementAndOrganization';
import { MarketAnalysis } from 'components/BusinessToolForm/Sections/MarketAnalysis';
import { MarketingAndSales } from 'components/BusinessToolForm/Sections/MarketingAndSales';
import { Overview } from 'components/BusinessToolForm/Sections/Overview';
import { ProductsAndServices } from 'components/BusinessToolForm/Sections/ProductsAndServices';
import { RaisingAndAllocatingFunds } from 'components/BusinessToolForm/Sections/RaisingAndAllocatingFunds';

export type IForBankFormSubSections = {
  [key in IUnitedSubSections]?: React.ComponentType;
};

export type IForBankFormSections = {
  [key in IForBankSections]: React.ComponentType;
};

export const forBankSections: IForBankFormSections = {
  [FOR_BANK_SECTIONS.OVERVIEW]: Overview,
  [FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY]: ExecutiveSummary,
  [FOR_BANK_SECTIONS.ABOUT_COMPANY]: AboutCompany,
  [FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES]: ProductsAndServices,
  [FOR_BANK_SECTIONS.MARKET_ANALYSIS]: MarketAnalysis,
  [FOR_BANK_SECTIONS.MARKETING_AND_SALES]: MarketingAndSales,
  [FOR_BANK_SECTIONS.BUSINESS_OPERATIONS]: BusinessOperations,
  [FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: ManagementAndOrganization,
  [FOR_BANK_SECTIONS.IMPLEMENTATION_PLAN]: ImplementationPlan,
  [FOR_BANK_SECTIONS.RAISING_AND_ALLOCATING_FUNDS]: RaisingAndAllocatingFunds,
  [FOR_BANK_SECTIONS.LEGAL_FRAMEWORKS_AND_RISKS]: LegalFrameworkAndRisks,
  [FOR_BANK_SECTIONS.FINANCIAL_PLAN]: FinancialPlan,
};
